// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".quicksearch[data-v-3eb03f83]{position:relative}.quicksearch[data-v-3eb03f83] .input__input{width:100%;max-height:100%;padding:12px 12px 12px 44px;font-size:16px;line-height:22px;color:#000}.quicksearch__search-icon[data-v-3eb03f83]{position:absolute;left:12px;top:15px;z-index:1;cursor:pointer;fill:#a363ff}[data-v-3eb03f83] .input__component-wrapper{border-radius:4px;margin-bottom:32px}", ""]);
// Exports
module.exports = exports;
